import {UserIncident} from "../../../../domain/incident/Incident";
import React, {FC} from "react";

type Props = {
    item: UserIncident;
};

export const IncidentRowZone: FC<Props> = ({item}) => {
    const {zone, submoduleId} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>ZONA</span>
            <span>{zone ? zone.label : submoduleId}</span>
        </div>
    );
};
